import React from "react";
import {SingleSelectItemContainer, SingleSelectItemSelectedContainer, SingleSelectItemTextContainer} from "./styled";

export const SingleSelectItem = ({selected, Icon, TopLabel, LowerLabel, RightLabel, onClick}: SingleSelectProps) => {
    if (selected) {
        return (
            <SingleSelectItemSelectedContainer>
                {Icon || <></>}

                <SingleSelectItemTextContainer onClick={onClick}>
                    {TopLabel}
                    {LowerLabel || <></>}
                </SingleSelectItemTextContainer>

                {RightLabel || <></>}
            </SingleSelectItemSelectedContainer>
        );
    } else {
        return (
            <SingleSelectItemContainer>
                {Icon || <></>}

                <SingleSelectItemTextContainer onClick={onClick}>
                    {TopLabel}
                    {LowerLabel || <></>}
                </SingleSelectItemTextContainer>

                {RightLabel || <></>}
            </SingleSelectItemContainer>
        );
    }
}

type SingleSelectProps = {
    Icon?: JSX.Element,
    TopLabel: JSX.Element,
    LowerLabel: JSX.Element,
    RightLabel?: JSX.Element,

    selected: boolean,
    onClick?: () => void,
}